import React from 'react';

import { useAppContext } from 'src/components/app-context';
import { useCampaignCardContext } from './campaign-card-context';

import { Clickable } from 'src/components/clickable';
import { GridCardHeader } from 'src/components/product-card-new/components/grid/grid-card-header';
import { CampaignCardContent } from './components/campaign-card-content';
import { CampaignCardFooter } from './components/campaign-card-footer';

import { StyledCard, StyledCardActionArea } from './styles';
import { CampaignCardActionButton } from './components/campaign-card-action-button';

type CampaignCardProps = {
  className?: string;
};

export const CampaignCard = (props: CampaignCardProps) => {
  const { className } = props;

  const { diffPercentage, handleCardOnClick, image, internalLink, name } =
    useCampaignCardContext();

  const { renderMode } = useAppContext();

  const headerProps = {
    diffPercentage,
    imageSrc: image,
    name,
  };

  const MARGIN_REM = 0.75;

  return (
    <StyledCard className={className} paddingRem={MARGIN_REM}>
      <CampaignCardActionButton marginRem={MARGIN_REM} />

      <StyledCardActionArea
        container={Clickable}
        containerProps={{
          isExternal: renderMode === 'native',
          onClick: handleCardOnClick,
          to: internalLink,
        }}
      >
        <GridCardHeader
          {...headerProps}
          marginRem={MARGIN_REM}
          shouldLazyLoadImage
        />
        <CampaignCardContent />
      </StyledCardActionArea>

      <CampaignCardFooter />
    </StyledCard>
  );
};
